import { render, staticRenderFns } from "./Opportunites.vue?vue&type=template&id=5075a316&scoped=true&"
import script from "./Opportunites.vue?vue&type=script&lang=ts&"
export * from "./Opportunites.vue?vue&type=script&lang=ts&"
import style0 from "./Opportunites.vue?vue&type=style&index=0&id=5075a316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5075a316",
  null
  
)

export default component.exports